import { render, staticRenderFns } from "./KoioteSiloCanvas.vue?vue&type=template&id=6dc66972&scoped=true&"
import script from "./KoioteSiloCanvas.vue?vue&type=script&lang=js&"
export * from "./KoioteSiloCanvas.vue?vue&type=script&lang=js&"
import style0 from "./KoioteSiloCanvas.vue?vue&type=style&index=0&id=6dc66972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc66972",
  null
  
)

export default component.exports